<script>
import {formatMoney} from "@components/admin/filters";

export default {
  name: "LoanManagementTable",
  props: {
    structuredLender: {
      type: Object,
      default: {}
    }
  },
  data: () => ({
    projects: [],
    toggleSelectState: false,
    resume: {},
    projectChanges: {},
    filters: {
      project_id: null,
      asset_status: "collecting",
      credit_status: ["0_up_to_date"],
      status: null,
      pending_terms: null
    }
  }),
  computed: {
    projectFiltered() {
      let projectFiltered = this.projects;

      if(this.filters.asset_status !== null) {
        projectFiltered = projectFiltered.filter((p) => {
          return p.asset_status === this.filters.asset_status
        });
      }

      if (this.filters.credit_status.length > 0) {
        projectFiltered = projectFiltered.filter((p) => {
          return this.filters.credit_status.includes(p.credit_status)
        });
      }
      if (this.filters.status !== null) {
        projectFiltered = projectFiltered.filter((p) => {
          return p.selected === this.filters.status
        });
      }

      if (this.filters.pending_terms !== null) {
        projectFiltered = projectFiltered.filter((p) => {
          return p.pending_terms > this.filters.pending_terms
        });
      }

      return projectFiltered;
    },
    selectedProjectsCount() {
      return this.projects.filter((p) => p.selected === true).length;
    },
    selectedProjects() {
      return this.projects.filter((p) => p.selected === true);
    },
    maxAccumulatedValue() {
      return _.sum(this.selectedProjects.map((p) => p.max_value))
    },
    maxAccumulatedTotalValue() {
      return _.sum(this.selectedProjects.map((p) => p.total_value))
    },
    total_vpn_commission_selected() {
      return this.projects
          .filter(project => project.selected)
          .reduce((acc, project) => acc + project.max_commission_concentration, 0);
    },
    total_insolute_balance_selected() {
      return this.projects
          .filter(project => project.selected)
          .reduce((acc, project) => acc + project.max_balance_concentration, 0);
    },
    total_value_selected() {
      return this.total_insolute_balance_selected + this.total_vpn_commission_selected;
    }
  },
  mounted() {
    this.fetchProjectAvailable();
  },
  methods: {
    formatMoney,
    calculateCommissionConcentrationPercentage(projectCommission, totalCommission) {
      if (totalCommission === 0) {
        return 0;
      }
      return ((projectCommission / totalCommission) * 100).toFixed(2);
    },
    calculateBalanceConcentrationPercentage(projectDebitBalance, totalDebitBalance) {
      if (totalDebitBalance === 0) {
        return 0;
      }
      return ((projectDebitBalance / totalDebitBalance) * 100).toFixed(2);
    },
    toggleSelect() {
      this.projectFiltered
          .filter((p) => p.selected !== this.toggleSelectState)
          .forEach((project) => {
            project.selected = this.toggleSelectState;
            this.registerProjectChanged(project);
          });
    },
    async fetchProjectAvailable() {
      this.$vs.loading();
      try {
        const {data} = await axios.post(
            `/api/backoffice/treasury/trust-management/structured-lender/${this.structuredLender.id}/available-projects`
        )

        this.resume = data.resume;
        this.projects = data.projects;
        /*this.projects = data.projects.map((p) => {
          p.commission_concentration_percentage = this.calculateCommissionConcentrationPercentage(
              p.vpn_total_commission,
              data.resume.total_vpn_commission
          )
          p.balance_concentration_percentage = this.calculateBalanceConcentrationPercentage(
              p.debit_balance,
              data.resume.total_insolute_balance
          )
          p.max_commission_concentration = p.commission_concentration_percentage < (this.structuredLender.balance_concentration * 100)
            ? p.vpn_total_commission : this.resume.total_vpn_commission * this.structuredLender.commission_concentration;
          p.max_balance_concentration = p.balance_concentration_percentage < (this.structuredLender.commission_concentration * 100)
            ? p.debit_balance : this.resume.total_insolute_balance * this.structuredLender.balance_concentration;

          return p;
        });*/
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: "Ocurrió un error al cargar los proyectos",
          color: "danger"
        });
      }
    },
    registerProjectChanged(project) {
      this.projectChanges[project.id] = project;
    },
    async saveProjectAssignedHandler() {
      let assignProject = Object.values(this.projectChanges).filter(project => project.selected)
      let denyProject = Object.values(this.projectChanges).filter(project => !project.selected)
      this.$vs.loading();
      try {
        if (assignProject.length > 0) {
          await axios.post(`/api/backoffice/treasury/trust-management/structured-lender/${this.structuredLender.id}/assign-projects`, {
            ids: assignProject.map(project => project.id)
          });
        }

        if (denyProject.length > 0) {
          await axios.post(`/api/backoffice/treasury/trust-management/structured-lender/${this.structuredLender.id}/deny-projects`, {
            ids: denyProject.map(project => project.id)
          });
        }

        if (assignProject.length > 0 || denyProject.length > 0) {
          this.$vs.notify({
            title: "Éxito",
            text: "Proyectos asignados/denegados correctamente",
            color: "success"
          });

          this.$emit("onProjectsChanged", Object.values(this.projectChanges))
        }
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: "Ocurrió un error al guardar los datos",
          color: "danger"
        });
      }
    }
  }
}
</script>

<template>
  <div>
    <div class="resume flex gap-4 mb-2 text-sm">
      <div class="w-96 flex flex-col bg-grey-light p-4 rounded">
        <div class="flex justify-between gap-4">
          <div class="font-bold">Tasa</div>
          <div>{{structuredLender.discount_rate * 100}}%</div>
        </div>
        <div class="flex justify-between gap-4">
          <div class="font-bold">Crédito</div>
          <div>{{formatMoney(structuredLender.amount)}}</div>
        </div>
        <div class="flex justify-between gap-4">
          <div class="font-bold">Aforo Requerido</div>
          <div>{{structuredLender.loan_to_value_ratio}}</div>
        </div>
        <div class="flex justify-between gap-4 pb-2" style="border-bottom: 2px solid #b2b2b3;">
          <div class="font-bold">Concentración</div>
          <div>{{structuredLender.balance_concentration * 100}}%</div>
        </div>
        <div class="flex justify-between gap-4">
          <div class="font-bold">Valor máximo objetivo</div>
          <div>{{formatMoney(structuredLender.amount * structuredLender.loan_to_value_ratio)}}</div>
        </div>
        <div class="flex justify-between gap-4">
          <div class="font-bold">Concentración máx / proyecto</div>
          <div>{{formatMoney(structuredLender.amount * structuredLender.loan_to_value_ratio * structuredLender.balance_concentration)}}</div>
        </div>
      </div>

      <div class="w-96 flex flex-col bg-grey-light p-4 rounded">
        <h2 class="text-2xl font-bold mb-2">Portafolio RG</h2>
        <div class="flex justify-between gap-4">
          <div class="font-bold">Saldo insoluto total</div>
          <div>{{formatMoney(resume.total_insolute_balance)}}</div>
        </div>
        <div class="flex gap-4">
          <div class="font-bold">Comisiones totales</div>
          <div>{{formatMoney(resume.total_vpn_commission)}}</div>
        </div>
        <div class="flex justify-between gap-4">
          <div class="font-bold">Valor total</div>
          <div>{{formatMoney(resume.total_insolute_balance + resume.total_vpn_commission)}}</div>
        </div>
      </div>

      <div class="w-96 flex flex-col bg-grey-light p-4 rounded">
        <div class="flex justify-between gap-4">
          <div class="font-bold">Proyectos seleccionados</div>
          <div>{{selectedProjectsCount}}</div>
        </div>
        <div class="flex gap-4">
          <div class="font-bold">Valor máximo acumulado</div>
          <div>{{formatMoney(maxAccumulatedValue)}}</div>
        </div>
        <div class="flex justify-between gap-4">
          <div class="font-bold">Valor total acumulado</div>
          <div>{{formatMoney(maxAccumulatedTotalValue)}}</div>
        </div>
        <div class="flex justify-between gap-4">
          <div class="font-bold">Aforo real</div>
          <div>{{(maxAccumulatedValue/(structuredLender.amount * structuredLender.loan_to_value_ratio)).toFixed(2)}}</div>
        </div>
      </div>

      <div class="max-w-sm h-48 flex flex-col bg-grey-light p-4 rounded overflow-y-scroll">
        <div>
          <span class="font-bold">Proyectos seleccionados:</span> <br />
          {{projects.filter(p => p.selected).map(project => project.id).join(", ")}}
        </div>
      </div>

    </div>
    <div class="filters flex justify-between items-center gap-4 mb-4">
      <div class="flex gap-4">
        <vs-select label="Asset Status" v-model="filters.asset_status">
          <vs-select-item text="Todos" :value="null"/>
          <vs-select-item text="Collecting" value="collecting"/>
          <vs-select-item text="Investment Commitment" value="investment_commitment"/>
          <vs-select-item text="Assets Under Management" value="assets_under_management"/>
          <vs-select-item text="Assets In Mandate" value="assets_in_mandate"/>
          <vs-select-item text="Settled" value="settled"/>
          <vs-select-item text="Partial Default" value="partial_default"/>
          <vs-select-item text="Irrecoverable" value="irrecoverable"/>
        </vs-select>
        <vs-select multiple label="Credit Status" v-model="filters.credit_status">
          <vs-select-item text="0 - Al corriente" value="0_up_to_date"/>
          <vs-select-item text="1 - 10 días de gracia" value="1_10_grace_period"/>
          <vs-select-item text="11 - 30 días de retraso" value="11_30_delayed"/>
          <vs-select-item text="31 - 60 días de retraso" value="31_60_delayed"/>
          <vs-select-item text="61 - 90 días de retraso" value="61_90_delayed"/>
          <vs-select-item text="91 o más días de retraso" value="91_or_more"/>
        </vs-select>
        <vs-select label="Status" v-model="filters.status">
          <vs-select-item text="Todos" :value="null"/>
          <vs-select-item text="Seleccionado" :value="true"/>
          <vs-select-item text="No Seleccionados" :value="false"/>
        </vs-select>
        <vs-select label="Meses faltantes" v-model="filters.pending_terms">
          <vs-select-item text="Todos" :value="null"/>
          <vs-select-item text=">3 meses" :value="3"/>
        </vs-select>
      </div>
      <div>
        <vs-button @click="saveProjectAssignedHandler()">Asignar/Denegar</vs-button>
      </div>
    </div>
    <span class="font-semibold text-sm mb-2">
      Listando {{projectFiltered.length}} proyectos
    </span>
    <vs-table :data="projectFiltered" stripe>
      <template slot="thead">
        <vs-th>PID</vs-th>
        <vs-th>CID</vs-th>
        <vs-th>Alias</vs-th>
        <vs-th>Status del activo</vs-th>
        <vs-th>Status del crédito</vs-th>
        <vs-th>Share RG</vs-th>
        <vs-th>Saldo insoluto RG</vs-th>
        <vs-th>VPN Comisiones Solicitante</vs-th>
        <vs-th>Valor total</vs-th>
        <vs-th>Valor máximo</vs-th>
        <vs-th>Meses faltantes</vs-th>
        <!--<vs-th>Concentración saldo</vs-th>
        <vs-th>Concentración comisiones</vs-th>-->
        <!--<vs-th>Saldo máximo</vs-th>
        <vs-th>Comisiones máximo</vs-th>-->
        <vs-th class="flex items-center justify-center">
          <!-- select all/unselect checkbox -->
          <vs-checkbox
              @change="toggleSelect()"
              v-model="toggleSelectState"></vs-checkbox>
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr v-for="project in data">
          <vs-td>{{ project.id }}</vs-td>
          <vs-td>{{ project.client_id }}</vs-td>
          <vs-td>{{ project.alias }}</vs-td>
          <vs-td>{{ project.asset_status }}</vs-td>
          <vs-td>{{ project.credit_status }}</vs-td>
          <vs-td>{{ project.share.toFixed(4) }}</vs-td>
          <vs-td>{{ formatMoney(project.debit_balance) }}</vs-td>
          <vs-td>{{ formatMoney(project.vpn_total_commission) }}</vs-td>
          <vs-td>{{ formatMoney(project.total_value) }}</vs-td>
          <vs-td>{{formatMoney(project.max_value)}}</vs-td>
          <vs-td>{{project.pending_terms}}</vs-td>
          <!--<vs-td>{{ project.balance_concentration_percentage }}%</vs-td>
          <vs-td>{{ project.commission_concentration_percentage }}%</vs-td>-->
          <!--<vs-td>{{formatMoney(project.max_balance_concentration)}}</vs-td>
          <vs-td>{{formatMoney(project.max_commission_concentration)}}</vs-td>-->
          <vs-td>
            <vs-checkbox
                @change="registerProjectChanged(project)"
                v-model="project.selected"></vs-checkbox>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<style scoped>

</style>